<template>
  <div>
    <Header is-guest-route/>
    <CookiesAlert/>
    <transition name="router-anim">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/common/Header/Header";
import CookiesAlert from "@/components/common/CookiesAlert";

export default {
  name: "Unauthorized",
  components: {
    CookiesAlert,
    Header
  }
}
</script>